import { connect } from "react-redux";
import UserHelpdeskListing from "./helpdeskListing";
import { bindActionCreators } from "redux";
import {userHelpdeskListing, userconfigStatus} from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    helpdeskListDetails : state.UserHelpdesk.helpdesklisting,
    userconfigstatusDetails: state.UserHelpdesk.userconfigstatus,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userHelpdeskListing,
        userconfigStatus
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserHelpdeskListing);